import { DeploymentFeature } from '../../../shared/deploymentFeatures';
import { useIsDeploymentFeatureEnabled } from '../../helpers/features/deploymentFeatures';
import { useOrganizationLicenseConcludedSetting } from '../api/organization/useOrganizationLicenseConcludedSetting';

/**
 * Whether License Conclusions are enabled for the organization: the deployment must enable them in
 * config (`window.deploymentFeatures`) AND the organization must have turned on its
 * `licenseConcludedEnabled` setting. Mirrors `isLicenseConcludedEnabled` on the backend.
 * Uses React Query for automatic caching and request deduplication.
 */
const useIsLicenseConcludedEnabled = (organizationId: number) => {
  const isAvailableOnDeployment = useIsDeploymentFeatureEnabled(DeploymentFeature.LICENSE_CONCLUSIONS);
  const { data: settings, isLoading } = useOrganizationLicenseConcludedSetting(organizationId, isAvailableOnDeployment);

  if (isLoading) {
    return false;
  }

  const isSettingEnabled = settings?.licenseConcludedEnabled ?? false;

  return isAvailableOnDeployment && isSettingEnabled;
};

export default useIsLicenseConcludedEnabled;
